// extracted by mini-css-extract-plugin
export default {"loaderSpinner":"src-signer-app-parts-loader-spinner-loader-spinner-module__loaderSpinner--2K_r_"};